import { render, staticRenderFns } from "./group-setting.vue?vue&type=template&id=093459d9&"
import script from "./group-setting.vue?vue&type=script&lang=js&"
export * from "./group-setting.vue?vue&type=script&lang=js&"
import style0 from "./group-setting.vue?vue&type=style&index=0&id=093459d9&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports